import { render, staticRenderFns } from "./BetFailedAlert.vue?vue&type=template&id=4bc195fc"
import script from "./BetFailedAlert.vue?vue&type=script&lang=js"
export * from "./BetFailedAlert.vue?vue&type=script&lang=js"
import style0 from "./BetFailedAlert.vue?vue&type=style&index=0&id=4bc195fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports